export type LocationT = {
  title: string;
  description: string;
};

export type MakeT = "Volkswagen" | "Audi" | "VW Nutzfahrzeuge" | "Skoda";

export type ServiceT =
  | "Garantieversicherung"
  | "Wartung & Inspektion"
  | "Kaufpreisschutz"
  | "Kfz Versicherung";

export type FinancialServiceLinksT = Record<
  LocationT["title"],
  Partial<Record<MakeT, Record<ServiceT, string>>>
>;

export const FINANCIAL_SERVICE_LINKS: FinancialServiceLinksT = {
  Darmstadt: {
    Volkswagen: {
      Garantieversicherung:
        "https://garantie.vwfs.de/vw-nw/getdata/companynumber/18461000/sellernumber/063000",
      "Wartung & Inspektion":
        "https://www.wartung-inspektion.vwfs.de/vw/getdata/companynumber/18461000/agentnumber//dealername/Autohaus+J.+Wiest+%26+S%C3%B6hne+Gesellschaft+mit+beschr%C3%A4nkter+Haftung/dealeraddress/Hilpertstr.+6/dealerpostalcode/64295/dealercity/Darmstadt",
      Kaufpreisschutz:
        "https://kaufpreisschutz.vwfs.de/vw-kps/getdata/companynumber/18461000/sellernumber/063000",
      "Kfz Versicherung":
        "https://autoversicherung.vwfs.de/vw-kfz/getdata/companynumber/18461000/sellernumber/063000",
    },
    Audi: {
      Garantieversicherung:
        "https://garantie.vwfs.de/audi-nw/getdata/companynumber/18461000/sellernumber/063000",
      "Wartung & Inspektion":
        "https://www.wartung-inspektion.vwfs.de/audi/getdata/companynumber/18461000/agentnumber/16095/dealername/Autohaus+J.+Wiest+%26+S%C3%B6hne+Gesellschaft+mit+beschr%C3%A4nkter+Haftung/dealeraddress/Hilpertstr.+6/dealerpostalcode/64295/dealercity/Darmstadt",
      Kaufpreisschutz:
        "https://kaufpreisschutz.vwfs.de/audi-kps/getdata/companynumber/18461000/sellernumber/063000",
      "Kfz Versicherung":
        "https://autoversicherung.vwfs.de/audi-kfz/getdata/companynumber/18461000/sellernumber/063000",
    },
    "VW Nutzfahrzeuge": {
      Garantieversicherung:
        "https://garantie.vwfs.de/vw-nw/getdata/companynumber/18434100/sellernumber/063105",
      "Wartung & Inspektion":
        "https://www.wartung-inspektion.vwfs.de/vwn/getdata/companynumber/18434100/agentnumber/11523/dealername/Autohaus+J.+Wiest+%26+S%C3%B6hne+GmbH/dealeraddress/Riedstr.+5/dealerpostalcode/64295/dealercity/Darmstadt",
      Kaufpreisschutz:
        "https://kaufpreisschutz.vwfs.de/vw-kps/getdata/companynumber/18434100/sellernumber/063105",
      "Kfz Versicherung":
        "https://autoversicherung.vwfs.de/vw-kfz/getdata/companynumber/18434100/sellernumber/063105",
    },
    Skoda: {
      Garantieversicherung:
        "https://garantie.vwfs.de/skoda-nw/getdata/companynumber/17540886/sellernumber/505088",
      "Wartung & Inspektion":
        "https://www.wartung-inspektion.vwfs.de/skoda/getdata/companynumber/17540886/agentnumber/04106/dealername/Wiest+Automobile+GmbH/dealeraddress/Hilpertstr.+6/dealerpostalcode/64295/dealercity/Darmstadt",
      Kaufpreisschutz:
        "https://kaufpreisschutz.vwfs.de/skoda-kps/getdata/companynumber/17540886/sellernumber/505088",
      "Kfz Versicherung":
        "https://autoversicherung.vwfs.de/skoda-kfz/getdata/companynumber/17540886/sellernumber/505088",
    },
  },
  Bensheim: {
    Volkswagen: {
      Garantieversicherung:
        "https://garantie.vwfs.de/vw-nw/getdata/companynumber/18435475/sellernumber/063101",
      "Wartung & Inspektion":
        "https://www.wartung-inspektion.vwfs.de/vw/getdata/companynumber/18435475/agentnumber/34291/dealername/Autohaus+Wiest+GmbH/dealeraddress/Robert-Bosch-Str.+17-19/dealerpostalcode/64625/dealercity/Bensheim",
      Kaufpreisschutz:
        "https://kaufpreisschutz.vwfs.de/vw-kps/getdata/companynumber/18435475/sellernumber/063101",
      "Kfz Versicherung":
        "https://autoversicherung.vwfs.de/vw-kfz/getdata/companynumber/18435475/sellernumber/063101",
    },
    Audi: {
      Garantieversicherung:
        "https://garantie.vwfs.de/audi-nw/getdata/companynumber/18435475/sellernumber/063101",
      "Wartung & Inspektion":
        "https://www.wartung-inspektion.vwfs.de/audi/getdata/companynumber/18435475/agentnumber/05760/dealername/Autohaus+Wiest+GmbH/dealeraddress/Robert-Bosch-Str.+17-19/dealerpostalcode/64625/dealercity/Bensheim",
      Kaufpreisschutz:
        "https://kaufpreisschutz.vwfs.de/audi-kps/getdata/companynumber/18435475/sellernumber/063101",
      "Kfz Versicherung":
        "https://autoversicherung.vwfs.de/audi-kfz/getdata/companynumber/18435475/sellernumber/063101",
    },
  },
};
